import {FormGroup, Input, Label} from "reactstrap";
import React from "react";

export const CustomInputComponent = (props) => {
    const {label,error,formik,className, ...rest} = props;

    return (
        <FormGroup className="form-group">
            {label && (
                <Label className="col-form-label">{label}</Label>
            )}
            <Input {...rest} />
        </FormGroup>
    );
}

export const CustomCheckComponent = (props) => {
    const {label,formik, ...rest} = props;
    return (
        <div className="d-block">
            <Input {...rest} id={props.name} />
            {' '}
            <Label check htmlFor={props.name}>
                {label}
            </Label>
        </div>
    );
}